import type { FaireProductEntity } from "../../entity_types/product";

export const p_6v8j2sfte6: FaireProductEntity = {
  token: "p_6v8j2sfte6",
  type: "product",
  name: "Cocktail and Cards / Naughty, Nice, Cocktails Card",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/836ecd0eba47259b8064df3c9f9fec003a5b8842d4168eebec82677b4fd6baf0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90020089d0f12fde2466850f6a8381785d3dddaef63bc905c8bf00b6a48c15b6.jpeg",
    "https://cdn.faire.com/fastly/8d50a7ed2a6c36077456b9bb3331c48daf7421fb90376631ad3bb55e26437da9.jpeg",
    "https://cdn.faire.com/fastly/a56b158bb5600c416fcf51d27b5eafe2714a3a29e1c8cf0ca66f16b12bfb1842.jpeg",
  ],
  priceDollars: 4.25,
  description:
    'These premium greeting cards each contain a single serve craft cocktail.  You can now send a "Cocktail and a Card"! Instead of just sending your loved one a card they throw away after reading it...they have a cocktail too! \n\nOur cards are 5" x 7" printed on a premium matte card stock.  The cards have gold foil details and the envelopes are gold foil lined and self adhesive.  Each card comes on a dust jacket.\n\nNoble Mick\'s single serve craft cocktails are the perfect way to enjoy a craft cocktail anywhere, anytime.  At home or on the go there is no need to have all the ingredients to make your favorite cocktail.  \n\nNoble Mick\'s is NOT an infusion product these cocktails are ready to go when you are. Simply add H2O and Spirit, shake or stir with ice and enjoy. Never overly sweet or artificial tasting.  Seriously...our cocktails are delicious!\n\nAt Noble Mick\'s we use all natural fruit and vegetable powders, natural spices and flavors and pure cane sugar.  There is a real difference!',
  tags: [],
  msrpDollars: 8.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:08.313Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
